import React from "react";
import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./index.scss";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import MasterCard from "../../assets/MasterCard.png";
import Lock from "../../assets/Lock.png";
import { Button } from "@material-ui/core";

class Premium extends React.Component {
	static propTypes = {
		me: PropTypes.array.isRequired
	};
	config = {
		public_key: "FLWPUBK_TEST-2c273244657524fcc9c605984e7fc65d-X",
		tx_ref: Date.now(),
		amount: 5 * this.props.match.params.length,
		currency: "USD",
		payment_options: "card,mobilemoney,ussd",
		payment_plan: 11795,
		customer: {
			email: this?.props?.me[0]?.email,
			name: this?.props?.me[0]?.name
		},
		customizations: {
			title: "My store",
			description: "Payment for items in cart",
			logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg"
		}
	};

	fwConfig = {
		...this.config,
		text: `Pay`,
		className: "Pay",
		callback: (response) => {
			console.log(response);
			if (response.status == "successful") {
				this.props.history.push("/success");
				console.log("Successfully Login");
			}
		},
		onClose: () => {}
	};

	render() {
		return (
			<div className="Payment">
				<div className="header">
					<KeyboardArrowLeftIcon onClick={() => this.props.history.goBack()} />
					<p className="Text">Check out</p>
					<p></p>
				</div>
				<p className="billing">BILLING</p>
				<div className="Card">
					<div>
						<h1 className="Total">TOTAL BILL</h1>
						<h1 className="Amount">$ {5 * this.props.match.params.length}.00</h1>
					</div>
					<div>
						<p className="DateText">Date</p>
						<p className="Date">2020-01-20</p>
					</div>
				</div>
				<p className="PaymentText">PAYMENT METHOD</p>
				<p className="PaymentDescription">Select card you want to use for payment</p>
				<div className="PaymentCard">
					<img src={MasterCard} className="Master" />
					<div className="Details">
						<p>Master card</p>
						<p>***********</p>
						<p>7546</p>
					</div>
				</div>
				<p className="AddCard">+ add your card</p>
				<div className="Secured">
					<img src={Lock} />
					<p>Secured Payment</p>
				</div>
				{/* <FlutterWaveButton {...this.fwConfig} /> */}

				{/* <Button
					type="submit"
					variant="contained"
					className="Pay"
					onClick={() => this.props.history.push("/success")}
				>
					Pay
				</Button> */}
				<FlutterWaveButton {...this.fwConfig} />
			</div>
		);
	}
}
const mapStateToProps = (state) => ({
	me: state.auth.me
});
export default connect(mapStateToProps)(Premium);
